import { IDeserializedPaginatedQuery } from "@smartrr/shared/utils/paginatedQuery";
import { InteractiveTable } from "@vendor-app/app/_sharedComponents/InteractiveDataTable";
import { HomeTableSorts } from "./sorts";
import { HomeTableFilters } from "./filters";

export const generateQueryFromStore = (
  selectedFilters: InteractiveTable.SelectedFilter[],
  selectedSort: InteractiveTable.SelectedSort,
  pagination: InteractiveTable.Pagination
): IDeserializedPaginatedQuery => {
  const query: IDeserializedPaginatedQuery = {
    pageNumber: pagination.pageNumber - 1,
    pageSize: 0,
  };

  for (const filter of selectedFilters) {
    const chosenFilter = HomeTableFilters.HomeTableFilters[filter.filterType];
    if (chosenFilter) {
      chosenFilter.addToQuery(query, filter.value);
    }
  }

  const chosenSort = HomeTableSorts.SortInfo[selectedSort.sortType];
  if (chosenSort) {
    query.orderBy = {
      [chosenSort.name]: selectedSort.value,
    };
  }

  return query;
};
